import { useHasPermission } from '~/modules/common/permissions';

export const useCanEditAllPrograms = () =>
  useHasPermission({
    actionUri: 'urn:replicon:program-action:edit-program',
    dataAccessLevelUri: 'urn:replicon:program-data-access-level:all'
  });
